export const randomInRange = (min: number, max: number) =>
  Math.random() * (max - min) + min;
